// extracted by mini-css-extract-plugin
export default {"tokenLoginPage":"TokenLogin_tokenLoginPage__82rGy","loadingContainer":"TokenLogin_loadingContainer__Dkp9i","loader":"TokenLogin_loader__7niE4"};